import {MenuItemType} from '@models/sidebar/menu-item-type';

export class UserMenuItem {
  id: string | null = null;
  name: string = '';
  machineId: string | null = null;
  pageId: string | null = null;
  firebaseUserId: string = '';
  index: number = -1;
  shared: boolean = false;
  parentId?: string | null = null;
  type: MenuItemType = MenuItemType.NONE;
  parent: any;
  organizationId?: number | null = null;
  machineCategory?: string | null = null;
}
